<template>
    <div class="borrow">
        <div class="search">
            <Button type="primary" icon="md-add" @click="show_add_banner = true">{{$t('add')}}{{$t('coin.new_banner')}}</Button>
        </div>
        <Table border :columns="columns12" :data="bannerList">
            <template slot-scope="{ row }" slot="status">
                <span v-if="row.status==1">{{$t('coin.already')}}{{$t('coin.open')}}</span>
                <span v-else>{{$t('coin.already')}}{{$t('coin.off')}}</span>
            </template>
            <template slot-scope="{ row }" slot="image">
                <img :src="row.image" style="width:100%;"></img>
            </template>
            <template slot-scope="{ row, index }" slot="action">
                <div class="op_btn">
                    <Button
                        type="info"
                        size="small"
                        style="margin-right: 5px"
                        @click="showBannerDetail(row.id)"
                    >{{$t('coin.edit')}}</Button>
                    <Button
                        v-if="row.status == 0"
                        type="success"
                        size="small"
                        style="margin-right: 5px"
                        @click="openModal(row)"
                    >{{$t('coin.open')}}</Button>
                    <Button
                        v-if="row.status == 1"
                        type="warning"
                        size="small"
                        style="margin-right: 5px"
                        @click="openModal(row)"
                    >{{$t('coin.off')}}</Button>
                    <Button
                        type="error"
                        size="small"
                        style="margin-right: 5px"
                        @click="showDelBanner(row)"
                    >{{$t('announcement.del')}}</Button>
                </div>
            </template>
            <template slot-scope="{ row }" slot="createtime">
                {{new Date(Date.parse(row.createtime)).toLocaleString()}}
            </template>
        </Table>
        <div class="page">
            <Page
                :total="totalItems"
                :page-size="itemsPerPage"
                show-elevator
                :current="currentPage"
                @on-change="loadData"
            />
        </div>

        <Modal
            v-model="showOkModal"
            :title="$t('coin.confirmOk')"
            @on-ok="change_staust(1)"
            @on-cancel="showOkModal=false"
        >
        </Modal>
        <Modal
            v-model="showCancelModal"
            :title="$t('coin.confirmCancel')"
            @on-ok="change_staust(0)"
            @on-cancel="showCancelModal=false"
        >
        </Modal>
        <Modal
            v-model="showDelModal"
            :title="$t('announcement.del')"
            @on-ok="delBanner()"
            @on-cancel="showDelModal=false"
        >
        </Modal>
        <Modal v-model="show_add_banner" :title="$t('announcement.add_new')" @on-ok="add_banner">
            <Form :model="modalAdd" ref="detail" :label-width="100">
                <input type="hidden" name="id" v-model="modalAdd.id">
                <Form :model="modalAdd" :label-width="100">
                    <FormItem :label="$t('coin.new_title')">
                      <div class="image-section orc_border2">
                        <img
                          v-model="modalAdd.image"
                          v-if="modalAdd.image"
                          :src="modalAdd.image"
                          class="card-image"
                          @click="identityFrontChooseImage"
                        />
                        <div
                          v-else
                          class="upload-area"
                          @click="identityFrontChooseImage"
                        >
                          <div class="upload-placeholder">
                            <span class="plus-icon">+</span>
                            <span>{{ $t('coin.new_upload') }}</span>
                          </div>
                        </div>
                      </div>
                    </FormItem>
                </Form>

                <FormItem :label="$t('status')">
                    <Select v-model="modalAdd.status">
                        <Option value="1">{{$t('coin.open')}}</Option>
                        <Option value="0">{{$t('coin.off')}}</Option>
                    </Select>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>
<script>
export default {
    data() {
        return {
            modalItem: {},
            currentPage: 1,
            totalPages: 1,
            itemsPerPage: 10,
            totalItems: 0,
            showOkModal: false,
            showCancelModal: false,
            show_add_banner: false,
            showDelModal: false,
            columns12: [
                {
                    title: "ID",
                    width: 80,
                    key: "id",
                },
                {
                    title: this.$i18n.t('coin.icon'),
                    width: 550,
                    key: "image",
                    slot: "image"
                },
                {
                    title: this.$i18n.t('coin.status'),
                    width: 100,
                    key: "status",
                    slot:"status"
                },
                {
                    title: this.$i18n.t('coin.create_time'),
                    width: 200,
                    key: "createtime",
                    slot: "createtime"
                },
                {
                    title: this.$i18n.t('action'),
                    slot: "action",
                    width: 200,
                    align: "center",
                    fixed:"right"
                }
            ],
            bannerList: [],
            modalAdd: {
                id:0,
                image: "",
                url:"",
                status:""
            },
        };
    },
    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(page) {
            this.currentPage = page;
            this.$get(this.$path.banner_list, {
                page: this.currentPage,
            }).then(res => {
                if (res.data) {
                    this.bannerList = res.data.list;
                    this.totalItems = res.data.pageObj.totalSize;
                    this.itemsPerPage = res.data.pageObj.pageSize;
                } else {
                    this.$Message.error(this.$i18n.t('dataFailed'));
                }
            });
        },
        openModal(row) {
          this.modalItem = row;
          if(this.modalItem.status == 1){
            this.showCancelModal = true;
          }else{
            this.showOkModal = true;
          }
        },
        change_staust(status) {
          this.$post(this.$path.change_banner_status, {
              id: this.modalItem.id,
              status: status
          }).then(res => {
              if (res.success) {
                  this.$Message.success(this.$i18n.t('operateSuccess'));
                  this.loadData(this.currentPage);
              }
          });
        },
        add_banner() {
          this.$post(this.$path.add_banner, {
              id: this.modalAdd.id,
              image: this.modalAdd.image,
              url: this.modalAdd.url,
              status: this.modalAdd.status
          }).then(res => {
              if (res.success) {
                  this.$Message.success(this.$i18n.t('operateSuccess'));
                  this.loadData(this.currentPage);
                  this.modalAdd = {id:0, image: "", url:"", status:""};
              }
          });
        },
        showBannerDetail(id){
          for(let ann of this.bannerList){
            if(ann.id == id){
              this.modalAdd.id = ann.id;
              this.modalAdd.image = ann.image;
              this.modalAdd.url = ann.url;
              this.modalAdd.status = ann.status;
              this.show_add_banner = true;
              break;
            }
          }
        },
        showDelBanner(row) {
          this.modalItem = row;
          this.showDelModal = true;
        },
        delBanner() {
          this.$post(this.$path.del_banner, {
              id: this.modalItem.id
          }).then(res => {
              if (res.success) {
                  this.$Message.success(this.$i18n.t('operateSuccess'));
                  this.loadData(this.currentPage);
                  this.modalAdd = {id:0, title_en: "", content_en:"", is_open:""};
              }
          });
        },
        /**
         * 选择身份证正面照片
         */
        async identityFrontChooseImage() {
          try {
            // 创建文件输入元素
            const input = document.createElement('input')
            input.type = 'file'
            input.accept = 'image/*'

            input.onchange = async (event) => {
              const file = event.target.files[0]
              if (file) {
                await this.uploadImage(file);
              }
            }

            input.click()
            this.showPopup = false
          } catch (error) {
            console.error(error)
          }
        },
        /**
         * 上传文件处理
         */
        async uploadImage(file) {
            const formData = new FormData()
            formData.append('img', file)
            //this.$toast.showLoading(this.$t('mine.introduce.loading'))
            this.$file(this.$path.upload, formData)
            .then(async res => {
              //this.$toast.hideLoading();
              if (res.success === true) {
                this.modalAdd.image = (this.$path.ip + res.data.path)
              }else{

              }
            })
            .catch(err => {
              //this.$toast.hideLoading();
            })
        }
    }
};
</script>
<style lang="scss" scoped>
.search {
    margin-bottom: 20px;
    .add_coin {
        float: right;
    }
}
.page {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
.jt_img {
    width: 100%;
    img {
        width: 100%;
    }
}
.order_num {
    display: flex;
    flex-direction: row;
    .tit {
        width: 60px;
        color: #bab9b9;
    }
    .info {
        width: 200px;
    }
}
.sts_list {
    margin-top: 10px;
    .tit {
        width: 100px;
        color: #bab9b9;
    }
}
.op_btn {
    margin-top: 5px;
}
.op_btn:nth-child(2) {
    margin-bottom: 5px;
}
/*.radio_div {
     width: 25%;
}*/
.ivu-radio-group {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
.red_color{
    color: red;
}

.card-image {
  width: 100%;
  border-radius: 7px;
}

.upload-area {
  width: 100%;
  height: 230px;
  background: #f8f9fa;
  border: 2px dashed #ccc;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  cursor: pointer;
}

.upload-placeholder {
  text-align: center;
  color: #999;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.plus-icon {
  font-size: 20px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/system/banner.vue